import React from 'react';
import { Props as IconProps, IconSize } from '../IconWrap';
import FileIcon from '../24x24/File';
import GifIcon from '../24x24/AddGif';
import VideoIcon from '../24x24/AddVideo';

import s from './SmartAttachment.scss';

interface Props extends IconProps {
  type?: string;
}

// A wrapper that receives a file type/extension (what we get from PAPI),
// tries to guess the file type and spits out a matching icon
const SmartAttachmentIcon: React.FC<Props> = ({ type = '', ...props }) => {
  let Icon = FileIcon;

  if (type === 'gif') {
    Icon = GifIcon;
  } else if (['jpg', 'jpeg', 'png', 'bmp', 'tiff'].includes(type)) {
    return (
      <div className={s['monalisa-wrapper']}>
        <div className={s['monalisa-icon']} />
      </div>
    );
  } else if (['mp4', 'mov', 'avi', 'wmv'].includes(type)) {
    Icon = VideoIcon;
  }
  return <Icon size={IconSize.SMALL} {...props} />;
};
SmartAttachmentIcon.displayName = 'SmartAttachmentIcon';

export default SmartAttachmentIcon;
